import DescriptionIcon from '@mui/icons-material/Description';
import { Button, Dialog, DialogActions, DialogTitle, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { action, observable, runInAction, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
import React, { Fragment } from 'react';
import { Minuta, Processo } from '../modelo';
import { HistoricoSituacaoMinutaDto } from '../modelo/HistoricoSituacaoMinuta';
import MinutaService from '../services/MinutaService';
import MensagemStore from '../store/MensagemStore';
import { EditNote } from '@mui/icons-material';
import Modal from '@/misc/Modal';

interface IPropsFuncaoSignatarioMinuta {
    processo?: Processo;
    minuta?: Minuta;
}


class FuncaoSignatarioMinuta extends React.Component<IPropsFuncaoSignatarioMinuta> {

    openModal = false;
    funcaoMagistrado = '';
    historicoMinuta: HistoricoSituacaoMinutaDto[] = [];
    salvando = false;


    constructor(props) {
        super(props);

        makeObservable(this, {
            openModal: observable,
            funcaoMagistrado: observable,
            historicoMinuta: observable,
            salvando: observable,
            salvarFuncaoMagistrado: action,
            abrirModal: action,
            fecharModal: action,
            handleChangeFuncaoSignatario: action
        });

        moment.locale('pt-BR');
    }

    salvarFuncaoMagistrado = async () => {
        if (this.props.minuta.situacaoMinuta.codigo <= 30 || this.props.minuta.situacaoMinuta.codigo == 70) {
            this.salvando = true;
            await MinutaService.gravarFuncaoMagistrado(this.props.minuta.idProcesso, this.props.minuta.tipo.codigo, this.funcaoMagistrado);
        }
        runInAction(() => {
            this.salvando = false;
        })
        this.fecharModal()
    };

    abrirModal = async () => {
        this.funcaoMagistrado = this.props.minuta?.textoFuncaoMagistrado != undefined ? this.props.minuta?.textoFuncaoMagistrado : ''
        runInAction(() => {
            this.openModal = true;
        });
    };

    fecharModal = () => {
        this.openModal = false;
    };

    handleChangeFuncaoSignatario = (event) => {
        this.funcaoMagistrado = event.target.value;
        if (this.funcaoMagistrado.length > 200) {
            this.funcaoMagistrado = this.funcaoMagistrado.substring(0, 200);
            MensagemStore.apresentarInformacao('A função do signatário não pode passar de 200 caracteres.');
        }
    };

    render() {
        return (
            <>
                {this.props.minuta?.cpfUltimaAlteracao &&
                    <Fragment>
                        <Tooltip title={"Clique para modificar o signatário desta minuta"}>
                            <IconButton color={this.props.minuta?.textoFuncaoMagistrado != undefined && this.props.minuta?.textoFuncaoMagistrado != '' ? 'primary' : 'default'}
                                size='small' style={{ padding: "3px 3px 0px 3px" }} onClick={this.abrirModal}>
                                <EditNote />
                            </IconButton>
                        </Tooltip>
                        <Modal
                            aberto={this.openModal}
                            fecharModal={this.fecharModal}
                            funcaoAcaoPrimaria={this.salvarFuncaoMagistrado}
                            labelAcaoPrimaria='Salvar'
                            funcaoAcaoSecundaria={this.fecharModal}
                            labelAcaoSecundaria='Fechar'
                            titulo='Função do Magistrado'
                            maxWidth='lg' fullWidth
                        >
                            <Typography style={{ marginBottom: 15, marginLeft: 24, marginRight: 24 }}>
                                Preencha a função do Magistrado signatário desta minuta
                            </Typography>
                            <TextField disabled={this.props.minuta.situacaoMinuta.codigo > 30 && this.props.minuta.situacaoMinuta.codigo < 70}
                                style={{ marginLeft: 24, marginRight: 24, width: 'calc(100% - 48px)' }}
                                value={this.funcaoMagistrado}
                                onChange={this.handleChangeFuncaoSignatario} />
                        </Modal>
                    </Fragment>
                }
            </>
        );
    }
}

export default observer(FuncaoSignatarioMinuta);
